import React from 'react'
import { Card, CardContent } from '../../../components/ui/card'
import { cn } from '../../../lib/utils'

// Vertical mobile-friendly stat card. Reads cleanly at half-width when
// the grid is 2-col on small screens.
export function StatCard({ label, value, unit, icon: Icon, colorClass = 'text-app-primary-500' }) {
  return (
    <Card>
      <CardContent className="p-3 sm:p-4">
        {Icon && (
          <div className={cn(
            'inline-flex p-1.5 rounded-md mb-2 bg-app-primary-100 dark:bg-app-primary-900/30',
            colorClass
          )}>
            <Icon className="w-4 h-4" />
          </div>
        )}
        <p className="text-[11px] sm:text-xs text-muted-foreground line-clamp-1">
          {label}
        </p>
        <p className={cn('text-base sm:text-lg font-bold font-mono mt-0.5 leading-tight', colorClass)}>
          {value != null ? value : '—'}
          {unit && value != null && (
            <span className="text-[10px] sm:text-xs font-normal text-muted-foreground ms-1">
              {unit}
            </span>
          )}
        </p>
      </CardContent>
    </Card>
  )
}
